export enum State {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
}

export const stateNames = {
  [State.AL]: {fr: 'Alabama', en: 'Alabama'},
  [State.AK]: {fr: 'Alaska', en: 'Alaska'},
  [State.AZ]: {fr: 'Arizona', en: 'Arizona'},
  [State.AR]: {fr: 'Arkansas', en: 'Arkansas'},
  [State.CA]: {fr: 'Californie', en: 'California'},
  [State.CO]: {fr: 'Colorado', en: 'Colorado'},
  [State.CT]: {fr: 'Connecticut', en: 'Connecticut'},
  [State.DE]: {fr: 'Delaware', en: 'Delaware'},
  [State.FL]: {fr: 'Floride', en: 'Florida'},
  [State.GA]: {fr: 'Géorgie', en: 'Georgia'},
  [State.HI]: {fr: 'Hawaï', en: 'Hawaii'},
  [State.ID]: {fr: 'Idaho', en: 'Idaho'},
  [State.IL]: {fr: 'Illinois', en: 'Illinois'},
  [State.IN]: {fr: 'Indiana', en: 'Indiana'},
  [State.IA]: {fr: 'Iowa', en: 'Iowa'},
  [State.KS]: {fr: 'Kansas', en: 'Kansas'},
  [State.KY]: {fr: 'Kentucky', en: 'Kentucky'},
  [State.LA]: {fr: 'Louisiane', en: 'Louisiana'},
  [State.ME]: {fr: 'Maine', en: 'Maine'},
  [State.MD]: {fr: 'Maryland', en: 'Maryland'},
  [State.MA]: {fr: 'Massachusetts', en: 'Massachusetts'},
  [State.MI]: {fr: 'Michigan', en: 'Michigan'},
  [State.MN]: {fr: 'Minnesota', en: 'Minnesota'},
  [State.MS]: {fr: 'Mississippi', en: 'Mississippi'},
  [State.MO]: {fr: 'Missouri', en: 'Missouri'},
  [State.MT]: {fr: 'Montana', en: 'Montana'},
  [State.NE]: {fr: 'Nebraska', en: 'Nebraska'},
  [State.NV]: {fr: 'Nevada', en: 'Nevada'},
  [State.NH]: {fr: 'New Hampshire', en: 'New Hampshire'},
  [State.NJ]: {fr: 'New Jersey', en: 'New Jersey'},
  [State.NM]: {fr: 'Nouveau-Mexique', en: 'New Mexico'},
  [State.NY]: {fr: 'New York', en: 'New York'},
  [State.NC]: {fr: 'Caroline du Nord', en: 'North Carolina'},
  [State.ND]: {fr: 'Dakota du Nord', en: 'North Dakota'},
  [State.OH]: {fr: 'Ohio', en: 'Ohio'},
  [State.OK]: {fr: 'Oklahoma', en: 'Oklahoma'},
  [State.OR]: {fr: 'Oregon', en: 'Oregon'},
  [State.PA]: {fr: 'Pennsylvanie', en: 'Pennsylvania'},
  [State.RI]: {fr: 'Rhode Island', en: 'Rhode Island'},
  [State.SC]: {fr: 'Caroline du Sud', en: 'South Carolina'},
  [State.SD]: {fr: 'Dakota du Sud', en: 'South Dakota'},
  [State.TN]: {fr: 'Tennessee', en: 'Tennessee'},
  [State.TX]: {fr: 'Texas', en: 'Texas'},
  [State.UT]: {fr: 'Utah', en: 'Utah'},
  [State.VT]: {fr: 'Vermont', en: 'Vermont'},
  [State.VA]: {fr: 'Virginie', en: 'Virginia'},
  [State.WA]: {fr: 'Washington', en: 'Washington'},
  [State.WV]: {fr: 'Virginie-Occidentale', en: 'West Virginia'},
  [State.WI]: {fr: 'Wisconsin', en: 'Wisconsin'},
  [State.WY]: {fr: 'Wyoming', en: 'Wyoming'},
};
